import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { TInputAppLoaderIdentifier } from '@monorepo/types';
import { LOCAL_STORAGE_UTILS } from '../localStorage.utils';
@Injectable({ providedIn: 'root' })
export class InputAppErrorDisplay {
  private loaders: Record<TInputAppLoaderIdentifier, any> = {
    POLL_FOR_EVENTS_BG_LOCK: undefined,
    SYNCING_PENDING_EVENTS: undefined,
    RESTORING_FOR_BACKED_UP_BCTX: undefined,
    LOAD_OPERATION_ISSUE_MAPPING: undefined,
    LOAD_SILHOUETTE_INFO: undefined,
    LOAD_SILHOUETTE_OPERATIONS: undefined,
    LOAD_CORRECTIVE_REASONS: undefined,
    LOAD_MASTER_DATA_LIST: undefined,
    WRITE_SILHOUETTE_IMAGES: undefined,
    LOADING_ALL_MASTER_DATA_LIST_WITH_SILHOUETTE: undefined,
    UPDATE_MASTER_DATA_LIST: undefined,
    LOADING_CORRECTIVE_REASONS_SUCCESS: undefined,
    UPDATE_FILTERED_LISTS: undefined,
    UPDATE_FILTERED_REJECT_LIST: undefined,
    SYNCING_PENDING_DEFECTIVE_IMAGES: undefined,
    CONNECTING_TO_SCANNER: undefined,
    UPDATE_DEVICE_LIST: undefined,
    USER_DISCONNECT_SCANNER: undefined,
    BCTX_SYNCING: undefined,
    DOWNLOAD_SILHOUETTE_ASSETS: undefined,
    LOADING_SERVER_DEFECTIVES: undefined,
    FETCH_PER_PIECE_LINE_IN_TRANSACTIONS: undefined,
    ADDING_EVENT: undefined,
    VALIDATING_UNDO_EVENT: undefined,
    NOTIFY_BCTX_CHANGE: undefined,
    ONLINE_RESTORE_WIP_AND_ACTUALS: undefined,
    ONLINE_RESTORE_TO_BE_RECTIFIED_COUNTS: undefined,
    ONLINE_RESTORE_TO_BE_RECTIFIED_COUNTS_SUCCESS: undefined,
    ONLINE_ADD_MD_PASS: undefined,
    ONLINE_ADD_MD_DEFECT_OR_REJECT: undefined,
    ONLINE_BCTX_CHANGE: undefined,
    LOAD_TO_BE_RECTIFIED_DATA: undefined,
    FETCHING_APP_UPDATES: undefined,
    RE_FECTING_APP_MASTER: undefined,
    UPDATING_APP_MASTER: undefined,
    RESETTING_APP_CACHE: undefined,
    SYNCING_BEFORE_RESET: undefined,
    FETCHING_CUT_BANK_IN_SUBJECTS: undefined,
    FETCHING_CUT_BANK_OUT_SUBJECTS: undefined,
    LOGOUT_ACK_FOR_PENDING_EVENTS_START: undefined,
    LOGOUT_ACK_FOR_PENDING_EVENTS_END: undefined,
    SYNC_STYLE_INFO_PLANBASED: undefined,
    RESYNC_FAILED_EVENTS: undefined,
    UPDATING_ACTUALS: undefined,
    LOAD_RCA_HIERARCHICAL_DATA: undefined,
  };
  alarm: HTMLAudioElement = new Audio('/assets/common/mm_notif_sound.wav');
  alarmSoundFeatureEnabled: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private loadingController: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
  ) {}

  async presentLoading(message = 'Please wait') {
    const loading = await this.loadingController.create({
      message: message,
      backdropDismiss: false,
      keyboardClose: false,
    });
    await loading.present();
  }

  async dismissLoading() {
    await this.loadingController.dismiss();
  }

  async presentLoadingWithId(id: TInputAppLoaderIdentifier, message = 'Please wait') {
    if (this.loaders[id]) return;
    this.loaders[id] = true;
    const loading = await this.loadingController.create({
      message: message,
      backdropDismiss: false,
      keyboardClose: false,
    });
    await loading.present();
    this.loaders[id] = loading;
  }

  async dismissLoadingWithId(id: TInputAppLoaderIdentifier) {
    if (this.loaders[id]) {
      await this.loaders[id].dismiss();
      this.loaders[id] = undefined;
    }
  }

  async showToast(message: string) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      cssClass: 'success-tost',
      position: 'bottom',
    });
    await toast.present();
  }

  async showPopup(
    title: string,
    message: string,
    buttons = [
      {
        text: 'Ok',
      },
    ],
  ) {
    const alert = await this.alertCtrl.create({
      header: title,
      subHeader: message,
      buttons: buttons,
    });
    const isAlarmEnabled = LOCAL_STORAGE_UTILS.retrieveData('alarmSignal');
    if (isAlarmEnabled === 'enabled') {
      this.alarm.loop = true;
      this.alarm.play();
    }

    alert.onDidDismiss().then(() => {
      if (isAlarmEnabled === 'enabled') {
        this.alarm.pause();
        this.alarm.currentTime = 0;
      }
    });
    alert.present();
  }

  async showAlertAndPlayErrorSound(header: string, subHeader: string, playSoundInloop: boolean = false) {
    const alert = await this.alertCtrl.create({
      header,
      subHeader,
      buttons: [
        {
          text: 'Ok',
        },
      ],
    });
    this.alarm.loop = playSoundInloop;
    this.alarm.play();
    alert.onDidDismiss().then(() => {
      this.alarm.pause();
      this.alarm.currentTime = 0;
    });
    alert.present();
  }
}
